export const RESET_INSIGHTS = "RESET_INSIGHTS";
export const RESET_INSIGHT = "RESET_INSIGHT";
export const RESET_ERROR = "RESET_ERROR";

export const GET_INSIGHTS = "GET_INSIGHTS";
export const SET_INSIGHTS = "SET_INSIGHTS";

export const API_ERROR = "INSIGHTS_API_ERROR";

export const GET_INSIGHT = "GET_INSIGHT";
export const SET_INSIGHT = "SET_INSIGHT";

export const EDIT_INSIGHT = "EDIT_INSIGHT";
export const EDIT_INSIGHT_SUCCESS = "EDIT_INSIGHT_SUCCESS";

export const CREATE_INSIGHT = "CREATE_INSIGHT";
export const CREATE_INSIGHT_SUCCESS = "CREATE_INSIGHT_SUCCESS";

export const DELETE_INSIGHT = "DELETE_INSIGHT";
export const DELETE_INSIGHT_SUCCESS = "DELETE_INSIGHT_SUCCESS";
